/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 1485e4e32a53
 */

import * as z from "zod";

export type UploadPresetMutationResponse = {
  message: string;
  external_id: string;
};

export const UploadPresetMutationResponse$zodSchema: z.ZodType<
  UploadPresetMutationResponse
> = z.object({
  external_id: z.string().describe(
    "The unique identifier for the upload preset.",
  ),
  message: z.string().describe(
    "The result message (e.g., \"updated\" or \"deleted\").",
  ),
});
